module.exports = __webpack_public_path__ + "static/media/cross.744a3f6a.svg";